import styled from "styled-components";
import planSummaryBg from "../../../assets/svgs2026/planSummaryBg.svg";

export const Container = styled.section`
  border-radius: 10px;
  background: white;
  /* padding: 40px; */
`;

// High-visibility dark noise pattern (uses SVG alpha channel so base color is untouched)
const NOISE_PATTERN = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.45' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0   0 0 0 0 0   0 0 0 0 0   0 0 0 3 -1.2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`;

export const SumInsuredHeaderWrapper = styled.header`
  position: relative;
  
  clip-path: polygon(
    20px 0%,
    100% 0%,
    100% calc(100% - 18px),
    calc(100% - 20px) 100%,
    0% 100%,
    0% 20px
  );

  /* Deep purple base matching the image background */
  background-color: #3b2859;

  /* Layer 1: High-contrast alpha noise | Layer 2: Background Image */
  background-image: 
    ${NOISE_PATTERN},
    url(${planSummaryBg});

  /* Using normal mode because noise is already alpha-masked inside SVG */
  background-blend-mode: normal, normal;
  
  background-size: 220px 220px, cover;
  background-position: 0 0, center;
  background-repeat: repeat, no-repeat;
  
  padding: 36px 36px;
  display: flex;
  flex-direction: column;
  gap: 36px;

  & > :first-child {
    display: flex;
    flex-direction: ${({ isMultiline }) => (isMultiline ? "column" : "row")};
    gap: ${({ isMultiline }) => (isMultiline ? "24px" : "90px")};
    & > :first-child {
      width: ${({ isMultiline }) => (isMultiline ? "100%" : "440px")};
    }
  }

  & > section:not(:first-of-type) {
    display: flex;
    gap: 90px;
    & > *:not(:last-child) {
      padding-right: 70px;
    }
    & > :first-child {
      width: 230px;
    }
  }
`;

export const Divider = styled.div`
  width: 1px;
  background: #6b5e7766;
  height: 100%;
  min-height: 50px;
`;

export const DividerHidden = styled.div`
  /* width: 1px; */
  background: #6b5e7766;
  height: 100%;
  min-height: 50px;
`;

export const GradeStripHeader = styled.header`
  /* background: white; */
  /* padding: 0 16px; */
  border-radius: 6px;
  /* margin-bottom: 10px; */
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 24px;
`;

export const AttributeWrapper = styled.div`
  border: 1px solid #231a3d26;
  padding: 36px 34px;
  border-radius: 10px;
`;

export const AgeGridWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
`;

export const GradeAttributeDetailWrapper = styled.div`
  /* padding: 36px 34px;
  border: 1px solid #231a3d26; */
  border-radius: 10px;
  & > header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
  }
`;

export const GradeAttributesWrapper = styled.section`
  display: grid;
  gap: 60px;
`;

export const CoverageNotesList = styled.ul`
  list-style: none; /* Remove default bullet */
  padding-left: 0;
  margin: 0;

  & > li {
    display: flex;
    align-items: center; /* Vertically centers the dot with the line/block */
    gap: 12px; /* Space between dot and text */
    margin-bottom: 6px;
    line-height: 1.4;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    margin-left: 2rem;

    &::before {
      content: "";
      width: 6px; /* Dot size */
      height: 6px;
      border-radius: 50%;
      background-color: currentColor; /* Matches text color */
      flex-shrink: 0; /* Prevents dot from squeezing on text wrap */
    }
  }
`;

export const GradeAttributeCardWrapper = styled.section`
  & > header {
    background-color: #452d84;
    border-radius: 4px 4px 0px 0px;
    max-width: 200px;
    padding: 8px 10px;
  }
  & > article {
    border: 1px solid #231a3d66;
    padding: 24px 14px;
    border-radius: 0px 4px 4px 4px;
  }
`;

const ExclusionBtn = styled.button`
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  font-family: "Inter";
  font-weight: 500;
  /* width: 212px;
  height: 54px; */
  width: 11.04vw;
  height: 5.0vh;
  padding: 2.4rem;
`

export const ExclusionBtnLight = styled(ExclusionBtn)`
  border: 1px solid rgb(35, 26, 61);
  color: rgb(35, 26, 61);
  background-color: transparent;
  
`;

export const ExclusionBtnDark = styled(ExclusionBtn)`
  border: 1px solid rgba(69, 45, 132, 1);
  color: #fff;
  background-color: rgba(69, 45, 132, 1);
`;


export const ExclusionDivContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 36px;
`;

export const ExclusionBtnWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: end;
  margin-top: 49px;
`

export const ModalCloseBtn = styled.div`
  cursor: pointer;
`

const ExclusionInputContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
`;

export const ExclusionTextInput = styled.div`
  width: 100%;
  background-color: transparent;
  padding: 1.6rem 2rem 1.6rem 2rem;
  outline: none;
  font-weight: 500;
  border: none;
  border: 1px solid #231a3d;
  border-radius: 10px;
  font-size: 16px;
  color: #4A4A4A;
  font-style: italic;
  letter-spacing: 2px;
  font-family: "Inter";
`;

export const ExclusionInputStyle = {
  width: '100%',
  backgroundColor: 'transparent',
  padding: '1.6rem 2rem',
  outline: 'none',
  fontWeight: 400,
  border: '1px solid #231a3d',
  borderRadius: '10px',
  fontSize: '14px',
  fontFamily: 'Inter',
  color: '#4A4A4A',
};

export const ExclusionDiv = styled.div`
  width: 90%;
  padding-right: 5rem;
  margin-right: auto;
  margin-top: 3rem;
`

export const CoverageDivWrapper = styled.div`
  width: 100%;
  padding-right: 5rem;
  padding-left: 2rem;
  margin-right: auto;
  margin-left: auto;
  font-size: 18px;
  display: flex;
  flex-direction : column;
  gap: 16px;
`
